// Browser/Vite version: safe to use import.meta.env
function getEnvVar(key, fallback = '') {
  try {
    if (typeof import.meta !== 'undefined' && import.meta.env && Object.prototype.hasOwnProperty.call(import.meta.env, key)) {
      return import.meta.env[key];
    }
  } catch {
    // Jest / Node environments do not support import.meta, so fall back to the non-browser value
  }

  return fallback;
}
export { getEnvVar };
